export const DashboardFeatureKey = 'dashboard';